import React, { useState , useEffect} from 'react'
import axios from "axios";
import { Snackbar, Grid, IconButton, Box} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './KnowledgeBase.css'
import KnowledgeTable from '../../components/KnowledgeTable/KnowledgeTable';
import AddKeyWord from '../../components/AddKeyWord/AddKeyWord';
import AddUnit from '../../components/AddUnit/AddUnit';
import EditValueType from '../../components/EditValueType/EditValueType'
import EditKeyWord from '../../components/EditKeyWord/EditKeyWord'
import EditUnit from '../../components/EditUnit/EditUnit';
import SideBar from '../../components/SideBar/SideBar';
import { URL } from '../../constants/constant';

const KnowledgeBase = () => {
    const [selectedRows, setSelectedRows] = useState([])
    const [tableData, setTableData] = useState([])
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [keyWords, setKeyWords] = useState([]);
    const [newKeyWord, setNewKeyWord] = useState('');
    const [units, setUnits] = useState([]);
    const [newUnit, setNewUnit] = useState('');

    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUserDetails"));

    const getTableData = async () => {
        let response = await axios.get(URL.demystify_url + 'knowledgeBase/fetchData');
        response.data.message.map((kb) => {
            if (kb.keywords) {
            kb.keywords = kb.keywords.replaceAll(', ', ',')
            kb.keywords = kb.keywords.replaceAll(',', ', ')
            }
            if (kb.units) {
                kb.units = kb.units.replaceAll(', ', ',')
                kb.units = kb.units.replaceAll(',', ', ')
            }
        })
        setTableData([...response.data.message])
    };

    useEffect(() => {
        getTableData()
    },[])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }
        setOpen(false);
    };

    const action = (
        <React.Fragment>
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
        </React.Fragment>
    );

    

    return (
        
        <div className='grid-container-knowledgeBase'>
            <div className='grid-sidebar'>
                <SideBar isTechTeam={loggedInUser.isTechTeam}/>
            </div>
            <div className='grid-knowledge-table'>
                <div className='knowledge-base'>
                    <h1> Knowledge Base </h1>
                </div>
                
                <Box display='flex' gap='2px' marginRight='3%' justifyContent="flex-end" >
                    <AddKeyWord  className='innerButton'
                        selectedRows={selectedRows} 
                        setOpen={setOpen} 
                        setMessage={setMessage} 
                        newKeyWord={newKeyWord} 
                        setNewKeyWord={setNewKeyWord} 
                        keyWords={keyWords} 
                        setKeyWords={setKeyWords}
                        getTableData={getTableData}
                    />
                    <EditKeyWord className='innerButton'
                        selectedRows={selectedRows} 
                        setOpen={setOpen} 
                        setMessage={setMessage}
                        getTableData={getTableData}
                    />
                    <AddUnit className='innerButton'
                        selectedRows={selectedRows} 
                        setOpen={setOpen} 
                        setMessage={setMessage} 
                        newUnit={newUnit} 
                        setNewUnit={setNewUnit} 
                        units={units} 
                        setUnits={setUnits}
                        getTableData={getTableData}
                    />
                    <EditUnit className='innerButton'
                        selectedRows={selectedRows} 
                        setOpen={setOpen} 
                        setMessage={setMessage}
                        getTableData={getTableData}
                    />
                    <EditValueType className='innerButton'
                        selectedRows={selectedRows}
                        setOpen={setOpen}
                        setMessage={setMessage}
                        getTableData={getTableData}
                    />
                </Box>
                <KnowledgeTable tableData={tableData} setSelectedRows={setSelectedRows} />
                <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} action={action} message={message}/>
            </div>
        </div>
    )

}

export default KnowledgeBase